module.exports = __webpack_public_path__ + "VIPM12.png?bc440e73906f23b3a1753d2d3a3d5605";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM12.png
// module id = 146
// module chunks = 0